<template>
  <div class="pa-4 custome-border-component fixed-height-comp">
    <v-row class="page-header mt-0">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold custom-title">
          {{
          $t("lbl.admin.recentFailedTransactions.page_header")
          }}
        </v-toolbar-title>
      </v-col>
    </v-row>

    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :class="[
            'list-table admin-process-style srm-list-table custom-border-table',
            listData.length > 0 ? '' : 'custom-border-table-not-data',
          ]"
          :fixed-header="true"
          hide-default-footer
          :height="tableHeight"
          disable-pagination
          disable-sort
        >
          <template v-slot:item.processId="{ item }">
            <font
              class="link-file-text cursor-pointer layout-col"
              @click="openDetail(item)"
            >{{item.processId}}</font>
          </template>
          <template v-slot:item.timestamp="{ item }">
            <font>{{applyGmtTimeZone(item.timestamp)}}</font>
          </template>
          <template v-slot:item.errorMessage="{ item }">
            <a class="link-file-text">
              <font
                :color="
                  statusColor_list(item.transactionCode, item.errorMessage)
                "
                @click="openErrorMessageWindow(item.errorMessage)"
              >{{ item.errorMessage }}</font>
            </a>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <ErrorMessage
        v-if="dialog.type == 'errorMessageWindow'"
        :id="dialog.id"
        title="Error Message"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :errorMessage="dialog.item.data"
      ></ErrorMessage>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { resizeTableHeight } from "@/vue-dlb/common/common";
import { mapState } from "vuex";
import ErrorMessage from "@/vue-caas/views/admin/EventMessageView.vue";
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";

const moment = require("moment");

export default {
  components: {
    ErrorMessage,
    SystemProgress,
  },
  data() {
    return {
      listData: [],
      dialogs: [],
      arrLayoutDialog: [],
      dialogId: 1,
      dialog: false,
      headers: [
        {
          text: this.$t("lbl.admin.owner_header"),
          value: "groupId",
          width: "130px",
        },
        {
          text: this.$t("lbl.admin.company_header"),
          value: "userId",
          width: "130px",
        },
        {
          text: this.$t("lbl.admin.process_header"),
          value: "processId",
          width: "150px",
        },
        {
          text: this.$t("lbl.admin.transaction"),
          value: "transactionCode",
          width: "180px",
        },
        {
          text: this.$t("lbl.admin.error"),
          value: "errorMessage",
          align: "center",
          width: "auto",
        },
        {
          text: this.$t("lbl.admin.dateTime"),
          value: "timestamp",
          align: "center",
          width: "160px",
        },
      ],
      isCreated: false,
      tableHeight: "",
      isLoading: false,
    };
  },

  computed: {
    ...mapState("common", {
      sysloadingTitle: "sysloadingTitle",
    }),
  },

  created() {
    this.getData();
    this.isCreated = true;
  },
  updated: function () {
    let self = this;
    let arrClassMinus = [".page-control-content"];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 292 + "px";
      this.isCreated = false;
    }

    $(window).resize(function (event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 292 + "px";
    });
  },
  methods: {
    applyGmtTimeZone(date) {
      let newM = "";
      if (date !== undefined && date !== "") {
        newM = moment
          .utc(date)
          .add(this.$cookies.get("gmt-timezone"), "hours")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      return newM;
    },
    openDetail(item) {
      this.$emit("select-ok", item);
    },
    getData() {
      this.isLoading = true;
      const params = {
        ownrId : this.$cookies.get("ownr-id")
      }
      this.$store
        .dispatch("getRecentFailedTransactionsList", params)
        .then(() => {
          this.listData = this.$store.getters.recentFailedTransactionsData;
          console.log(this.listData);
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    statusColor_list(status, errMsg) {
      if (status !== undefined) {
        if (
          status.indexOf("DONE") !== -1 &&
          (errMsg === undefined || errMsg === "")
        )
          return "#2a8c72";
        else if (
          status.indexOf("FAIL") !== -1 ||
          (errMsg !== undefined && errMsg !== "")
        )
          return "#EB1E50";
        else if (status.indexOf(undefined) !== -1) return "#EB1E50";
        else return "#6F5ECE";
      }
    },
    openErrorMessageWindow(message) {
      let type = "errorMessageWindow";
      let item = {
        ROWID: 1,
        data: message,
      };
      let indexArrDialog = this.findDialog("errorMessageWindow_1");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = "Dialog Recent " + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, item, options };
    },
    selectDialog(obj) {
      console.log(obj);
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, "left", obj.left);
      this.$set(this.dialogs[index].options, "top", obj.top);
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
  },
};
</script>